import { Col, Row } from 'antd';
import ContactsNode from './ContactsNode';
import Title from './Title';

const Contacts = (props) => {
  return (
    <>
      <Title label={props.title} image="images\Nutriarquivo_Grupo_Icon.png"></Title>
      <Row>
        {props.nodes.map((node, _) => {
          return (
            <>
              <Col flex="auto">
                <ContactsNode
                  name={node.name}
                  role={node.role}
                  link={node.link}
                  coordinator={node.coordinator}
                  isHome={true}
                />
              </Col>
            </>
          );
        })}
      </Row>
    </>
  );
};

export default Contacts;
